import { filter } from "@/assets";
import { DataTable, Dialog } from "@/components";
import { Button } from "@/components/ui";
import { Filter } from "./Filter";
import useInventorySetup from "./useInventorySetup";

const InventorySetup = () => {
  const {
    columns,
    onAdd,
    openDeleteDialog,
    setOpenDeleteDialog,
    onConfirmDelete,
    onCancelFilter,
    onFilterBtnClick,
    openFilter,
    filterData,
    setFilterData,
    tableData,
    isPending,
    isError,
    pageNumber,
    pageSize,
    totalPages,
    totalRecords,
    setPageNumber,
    setPageSize,
  } = useInventorySetup();

  return (
    <>
      <div className="mb-4 px-5 flex justify-end gap-3">
        <Button type="button" variant="ghost" onClick={onFilterBtnClick}>
          <img src={filter} />
          Filter
        </Button>
        <Button onClick={onAdd}>+ Add New</Button>
      </div>
      {isPending && <div className="px-5 py-3">Loading...</div>}
      {!isPending && !isError && (
        <DataTable
          columns={columns}
          data={tableData}
          serviceSidePagination
          pageNumber={pageNumber}
          pageSize={pageSize}
          totalPages={totalPages}
          totalRecords={totalRecords}
          setPageNumber={setPageNumber}
          setPageSize={setPageSize}
        />
      )}
      {openDeleteDialog && (
        <Dialog
          open={openDeleteDialog}
          setOpen={setOpenDeleteDialog}
          title="Delete Inventory"
          onSave={onConfirmDelete}
          saveText="Delete"
          saveBtnClassName="bg-red-600 hover:bg-red-500"
        >
          <div className="flex flex-col gap-4">
            <p>Are you sure you want to delete this inventory?</p>
          </div>
        </Dialog>
      )}

      {openFilter && (
        <Filter
          onCancel={onCancelFilter}
          filterData={filterData}
          setFilterData={setFilterData}
        />
      )}
    </>
  );
};

export default InventorySetup;
